/*
 *
 * THIS FILE IS GENERATED AUTOMATICALLY BY RUNNING pnpm generate-icon-aliases
 * DON'T EDIT IT MANUALLY
 *
 */

import { Icon } from './Icon';
import { IconName, IconProps } from './types';

export const AccountTreeIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ACCOUNT_TREE} {...iconProps} />
);

export const AddIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ADD} {...iconProps} />
);

export const AddBubbleIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ADD_BUBBLE} {...iconProps} />
);

export const AgentIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.AGENT} {...iconProps} />
);

export const AddCircleIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ADD_CIRCLE} {...iconProps} />
);

export const AfterIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.AFTER} {...iconProps} />
);

export const ArchiveIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ARCHIVE} {...iconProps} />
);

export const ArrowBackIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ARROW_BACK} {...iconProps} />
);

export const ArrowDownIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ARROW_DOWN} {...iconProps} />
);

export const ArrowDownwardIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ARROW_DOWNWARD} {...iconProps} />
);

export const ArrowForwardIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ARROW_FORWARD} {...iconProps} />
);

export const ArrowRightIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ARROW_RIGHT} {...iconProps} />
);

export const ArrowUpIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ARROW_UP} {...iconProps} />
);

export const ArrowUpwardIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ARROW_UPWARD} {...iconProps} />
);

export const AttachmentIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ATTACHMENT} {...iconProps} />
);

export const BeforeIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.BEFORE} {...iconProps} />
);

export const BlurOnIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.BLUR_ON} {...iconProps} />
);

export const BlurOffIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.BLUR_OFF} {...iconProps} />
);

export const BookmarkIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.BOOKMARK} {...iconProps} />
);

export const BubbleChartIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.BUBBLE_CHART} {...iconProps} />
);

export const CheckMarkIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CHECK_MARK} {...iconProps} />
);

export const CloseIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CLOSE} {...iconProps} />
);

export const CollapseAllIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.COLLAPSE_ALL} {...iconProps} />
);

export const CollapseVerticalIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.COLLAPSE_VERTICAL} {...iconProps} />
);

export const CloudDownloadIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CLOUD_DOWNLOAD} {...iconProps} />
);

export const CollectionsIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.COLLECTIONS} {...iconProps} />
);

export const CommentIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.COMMENT} {...iconProps} />
);

export const ComponentIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.COMPONENT} {...iconProps} />
);

export const ComputerIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.COMPUTER} {...iconProps} />
);

export const ContainerIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CONTAINER} {...iconProps} />
);

export const DeleteIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DELETE} {...iconProps} />
);

export const DescriptionIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DESCRIPTION} {...iconProps} />
);

export const DownloadIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DOWNLOAD} {...iconProps} />
);

export const DragIndicatorIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DRAG_INDICATOR} {...iconProps} />
);

export const EditIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.EDIT} {...iconProps} />
);

export const EventIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.EVENT} {...iconProps} />
);

export const ExitToAppIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.EXIT_TO_APP} {...iconProps} />
);

export const ExportIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.EXPORT} {...iconProps} />
);

export const ExtensionIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.EXTENSION} {...iconProps} />
);

export const FiberManualRecordIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FIBER_MANUAL_RECORD} {...iconProps} />
);

export const FileIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FILE} {...iconProps} />
);

export const FileCopyIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FILE_COPY} {...iconProps} />
);

export const FilterListIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FILTER_LIST} {...iconProps} />
);

export const FolderIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FOLDER} {...iconProps} />
);

export const FormatListBulletedIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FORMAT_LIST_BULLETED} {...iconProps} />
);

export const FormatListNumberedIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FORMAT_LIST_NUMBERED} {...iconProps} />
);

export const FormatSizeIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FORMAT_SIZE} {...iconProps} />
);

export const FullscreenIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FULLSCREEN} {...iconProps} />
);

export const FullscreenExitIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FULLSCREEN_EXIT} {...iconProps} />
);

export const GridOnIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.GRID_ON} {...iconProps} />
);

export const LayoutGridIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.LAYOUT_GRID} {...iconProps} />
);

export const HelpIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.HELP} {...iconProps} />
);

export const InfoIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.INFO} {...iconProps} />
);

export const KnowledgeBaseIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.KNOWLEDGE_BASE} {...iconProps} />
);

export const FlowChartIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FLOW_CHART} {...iconProps} />
);

export const LineChartIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.LINE_CHART} {...iconProps} />
);

export const TableChartIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TABLE_CHART} {...iconProps} />
);

export const LockIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.LOCK} {...iconProps} />
);

export const LockOpenIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.LOCK_OPEN} {...iconProps} />
);

export const MailIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.MAIL} {...iconProps} />
);

export const MoreHorizIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.MORE_HORIZ} {...iconProps} />
);

export const MoreVertIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.MORE_VERT} {...iconProps} />
);

export const NoneIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.NONE} {...iconProps} />
);

export const NotInterestedIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.NOT_INTERESTED} {...iconProps} />
);

export const NotificationsIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.NOTIFICATIONS} {...iconProps} />
);

export const NotificationsFilledIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.NOTIFICATIONS_FILLED} {...iconProps} />
);

export const ExpandAllIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.EXPAND_ALL} {...iconProps} />
);

export const ExpandVerticalIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.EXPAND_VERTICAL} {...iconProps} />
);

export const OpenInNewIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.OPEN_IN_NEW} {...iconProps} />
);

export const PaletteIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PALETTE} {...iconProps} />
);

export const PersonIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PERSON} {...iconProps} />
);

export const UserSettingsIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.USER_SETTINGS} {...iconProps} />
);

export const PriorityHighIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PRIORITY_HIGH} {...iconProps} />
);

export const ReferenceIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.REFERENCE} {...iconProps} />
);

export const RefreshIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.REFRESH} {...iconProps} />
);

export const RemoveIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.REMOVE} {...iconProps} />
);

export const SaveIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SAVE} {...iconProps} />
);

export const SearchIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SEARCH} {...iconProps} />
);

export const SettingsIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SETTINGS} {...iconProps} />
);

export const SigmaIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SIGMA} {...iconProps} />
);

export const SortIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SORT} {...iconProps} />
);

export const SpaceBarIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SPACE_BAR} {...iconProps} />
);

export const UnfoldLessIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.UNFOLD_LESS} {...iconProps} />
);

export const UnfoldMoreIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.UNFOLD_MORE} {...iconProps} />
);

export const UpdateIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.UPDATE} {...iconProps} />
);

export const VerticalAlignBottomIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.VERTICAL_ALIGN_BOTTOM} {...iconProps} />
);

export const ViewArrayIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.VIEW_ARRAY} {...iconProps} />
);

export const ViewCompactIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.VIEW_COMPACT} {...iconProps} />
);

export const OrientationHorizontalIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ORIENTATION_HORIZONTAL} {...iconProps} />
);

export const VisibilityIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.VISIBILITY} {...iconProps} />
);

export const VisibilityOffIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.VISIBILITY_OFF} {...iconProps} />
);

export const ZoomInIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ZOOM_IN} {...iconProps} />
);

export const ZoomOutIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ZOOM_OUT} {...iconProps} />
);

export const ZoomOutMapIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ZOOM_OUT_MAP} {...iconProps} />
);

export const ChevronUpIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CHEVRON_UP} {...iconProps} />
);

export const ChevronDownIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CHEVRON_DOWN} {...iconProps} />
);

export const ChevronLeftIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CHEVRON_LEFT} {...iconProps} />
);

export const ChevronRightIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CHEVRON_RIGHT} {...iconProps} />
);

export const Rotate90DegIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ROTATE_90_DEG} {...iconProps} />
);

export const AddChartIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ADD_CHART} {...iconProps} />
);

export const AddLinkIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ADD_LINK} {...iconProps} />
);

export const AddHeaderIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ADD_HEADER} {...iconProps} />
);

export const AddNoteIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ADD_NOTE} {...iconProps} />
);

export const AddPresentationIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ADD_PRESENTATION} {...iconProps} />
);

export const DatasetIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DATASET} {...iconProps} />
);

export const AiStarIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.AI_STAR} {...iconProps} />
);

export const AiAddChartIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.AI_ADD_CHART} {...iconProps} />
);

export const AiAddPresentationIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.AI_ADD_PRESENTATION} {...iconProps} />
);

export const AiEditIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.AI_EDIT} {...iconProps} />
);

export const AiFileIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.AI_FILE} {...iconProps} />
);

export const AiLightbulbIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.AI_LIGHTBULB} {...iconProps} />
);

export const AiPersonIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.AI_PERSON} {...iconProps} />
);

export const AiSearchIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.AI_SEARCH} {...iconProps} />
);

export const AiSyncIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.AI_SYNC} {...iconProps} />
);

export const AiTextIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.AI_TEXT} {...iconProps} />
);

export const AiImageIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.AI_IMAGE} {...iconProps} />
);

export const AlarmCancelledIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ALARM_CANCELLED} {...iconProps} />
);

export const AlarmErrorIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ALARM_ERROR} {...iconProps} />
);

export const AlarmSentIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ALARM_SENT} {...iconProps} />
);

export const AlarmToBeSentIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ALARM_TO_BE_SENT} {...iconProps} />
);

export const AnalyticsIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ANALYTICS} {...iconProps} />
);

export const AnimationPauseIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ANIMATION_PAUSE} {...iconProps} />
);

export const AnimationPlayIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ANIMATION_PLAY} {...iconProps} />
);

export const ApiIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.API} {...iconProps} />
);

export const ApplicationIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.APPLICATION} {...iconProps} />
);

export const ApplicationGroupIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.APPLICATION_GROUP} {...iconProps} />
);

export const ApplicationModuleIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.APPLICATION_MODULE} {...iconProps} />
);

export const ArchitectureStandardIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ARCHITECTURE_STANDARD} {...iconProps} />
);

export const ArrowRightAltIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ARROW_RIGHT_ALT} {...iconProps} />
);

export const ArrowRightLongIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ARROW_RIGHT_LONG} {...iconProps} />
);

export const ArrowTopAltIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ARROW_TOP_ALT} {...iconProps} />
);

export const ArrowsHIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ARROWS_H} {...iconProps} />
);

export const ArrowsHShrinkIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ARROWS_H_SHRINK} {...iconProps} />
);

export const AccessManagementIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ACCESS_MANAGEMENT} {...iconProps} />
);

export const AtIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.AT} {...iconProps} />
);

export const BarChartIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.BAR_CHART} {...iconProps} />
);

export const BetaIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.BETA} {...iconProps} />
);

export const BroadcastIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.BROADCAST} {...iconProps} />
);

export const BroadcastPlaceholderIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.BROADCAST_PLACEHOLDER} {...iconProps} />
);

export const BrokenImageIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.BROKEN_IMAGE} {...iconProps} />
);

export const BullseyeIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.BULLSEYE} {...iconProps} />
);

export const BusinessCapabilityIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.BUSINESS_CAPABILITY} {...iconProps} />
);

export const BusinessHealthCheckIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.BUSINESS_HEALTH_CHECK} {...iconProps} />
);

export const CalculatorIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CALCULATOR} {...iconProps} />
);

export const CalendarIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CALENDAR} {...iconProps} />
);

export const CapabilityDeltaIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CAPABILITY_DELTA} {...iconProps} />
);

export const CatalogLinkedIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CATALOG_LINKED} {...iconProps} />
);

export const CatalogPendingIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CATALOG_PENDING} {...iconProps} />
);

export const CatalogUnlinkedIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CATALOG_UNLINKED} {...iconProps} />
);

export const CategoryIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CATEGORY} {...iconProps} />
);

export const ChannelIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CHANNEL} {...iconProps} />
);

export const CheckboxCheckedIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CHECKBOX_CHECKED} {...iconProps} />
);

export const CheckboxItemIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CHECKBOX_ITEM} {...iconProps} />
);

export const CheckboxMixedIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CHECKBOX_MIXED} {...iconProps} />
);

export const CheckboxUncheckedIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CHECKBOX_UNCHECKED} {...iconProps} />
);

export const CheckboxUnsetIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CHECKBOX_UNSET} {...iconProps} />
);

export const CheckCircleIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CHECK_CIRCLE} {...iconProps} />
);

export const CircleIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CIRCLE} {...iconProps} />
);

export const CircleEmptyIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CIRCLE_EMPTY} {...iconProps} />
);

export const CodeIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CODE} {...iconProps} />
);

export const CodeBlockIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CODE_BLOCK} {...iconProps} />
);

export const CollapseGroupsIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.COLLAPSE_GROUPS} {...iconProps} />
);

export const ComplianceAssessmentIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.COMPLIANCE_ASSESSMENT} {...iconProps} />
);

export const ConditionalIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CONDITIONAL} {...iconProps} />
);

export const CrosshairsIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CROSSHAIRS} {...iconProps} />
);

export const ContractIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CONTRACT} {...iconProps} />
);

export const ControlIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CONTROL} {...iconProps} />
);

export const CopyIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.COPY} {...iconProps} />
);

export const CubeIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CUBE} {...iconProps} />
);

export const CubesIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CUBES} {...iconProps} />
);

export const CustomerSegmentIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CUSTOMER_SEGMENT} {...iconProps} />
);

export const DashboardIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DASHBOARD} {...iconProps} />
);

export const DateIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DATE} {...iconProps} />
);

export const DateTimeIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DATE_TIME} {...iconProps} />
);

export const DatabaseSearchIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DATABASE_SEARCH} {...iconProps} />
);

export const DataEntityIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DATA_ENTITY} {...iconProps} />
);

export const DataStoreIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DATA_STORE} {...iconProps} />
);

export const DebtItemIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DEBT_ITEM} {...iconProps} />
);

export const DecisionRecordIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DECISION_RECORD} {...iconProps} />
);

export const DesignObjectIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DESIGN_OBJECT} {...iconProps} />
);

export const DescriptionOutlinedIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DESCRIPTION_OUTLINED} {...iconProps} />
);

export const DiffIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DIFF} {...iconProps} />
);

export const DiffEmptyIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DIFF_EMPTY} {...iconProps} />
);

export const DigitalChannelIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DIGITAL_CHANNEL} {...iconProps} />
);

export const DigitalProductIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DIGITAL_PRODUCT} {...iconProps} />
);

export const DonutChartIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DONUT_CHART} {...iconProps} />
);

export const DuplicateIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DUPLICATE} {...iconProps} />
);

export const EdgeBundlingIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.EDGE_BUNDLING} {...iconProps} />
);

export const ErrorIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ERROR} {...iconProps} />
);

export const ExceptionRequestIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.EXCEPTION_REQUEST} {...iconProps} />
);

export const ExternallyManagedIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.EXTERNALLY_MANAGED} {...iconProps} />
);

export const ExternallyMissingIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.EXTERNALLY_MISSING} {...iconProps} />
);

export const FieldIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FIELD} {...iconProps} />
);

export const FileOutlinedIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FILE_OUTLINED} {...iconProps} />
);

export const FileUploadedIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FILE_UPLOADED} {...iconProps} />
);

export const FlipHorizontallyIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FLIP_HORIZONTALLY} {...iconProps} />
);

export const FlipVerticallyIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FLIP_VERTICALLY} {...iconProps} />
);

export const FlowIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FLOW} {...iconProps} />
);

export const FormatBoldIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FORMAT_BOLD} {...iconProps} />
);

export const FormatItalicIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FORMAT_ITALIC} {...iconProps} />
);

export const FormatQuoteIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FORMAT_QUOTE} {...iconProps} />
);

export const FourSquareGridIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FOUR_SQUARE_GRID} {...iconProps} />
);

export const FourSquareTopLeftIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FOUR_SQUARE_TOP_LEFT} {...iconProps} />
);

export const FourSquareTopRightIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FOUR_SQUARE_TOP_RIGHT} {...iconProps} />
);

export const FourSquareBottomLeftIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FOUR_SQUARE_BOTTOM_LEFT} {...iconProps} />
);

export const FourSquareBottomRightIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FOUR_SQUARE_BOTTOM_RIGHT} {...iconProps} />
);

export const FutureStateIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FUTURE_STATE} {...iconProps} />
);

export const GithubIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.GITHUB} {...iconProps} />
);

export const GlobeIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.GLOBE} {...iconProps} />
);

export const GlobeDisabledIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.GLOBE_DISABLED} {...iconProps} />
);

export const GoogleIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.GOOGLE} {...iconProps} />
);

export const HideComponentIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.HIDE_COMPONENT} {...iconProps} />
);

export const HistoryIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.HISTORY} {...iconProps} />
);

export const HomeIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.HOME} {...iconProps} />
);

export const IncludeReferenceParentsIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.INCLUDE_REFERENCE_PARENTS} {...iconProps} />
);

export const InformationArtifactIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.INFORMATION_ARTIFACT} {...iconProps} />
);

export const InitiativeIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.INITIATIVE} {...iconProps} />
);

export const TransformationInitiativeIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TRANSFORMATION_INITIATIVE} {...iconProps} />
);

export const IntegrationIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.INTEGRATION} {...iconProps} />
);

export const InterfaceIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.INTERFACE} {...iconProps} />
);

export const InventoryIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.INVENTORY} {...iconProps} />
);

export const KeyIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.KEY} {...iconProps} />
);

export const KeyResultIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.KEY_RESULT} {...iconProps} />
);

export const LabelOutlinedIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.LABEL_OUTLINED} {...iconProps} />
);

export const LanguageIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.LANGUAGE} {...iconProps} />
);

export const LayoutSettingsIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.LAYOUT_SETTINGS} {...iconProps} />
);

export const LevelDownIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.LEVEL_DOWN} {...iconProps} />
);

export const LevelLeftIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.LEVEL_LEFT} {...iconProps} />
);

export const LinkIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.LINK} {...iconProps} />
);

export const ListIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.LIST} {...iconProps} />
);

export const LocationIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.LOCATION} {...iconProps} />
);

export const LogOutIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.LOG_OUT} {...iconProps} />
);

export const LucidchartIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.LUCIDCHART} {...iconProps} />
);

export const ManagedWorkspaceIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.MANAGED_WORKSPACE} {...iconProps} />
);

export const MarketIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.MARKET} {...iconProps} />
);

export const MasterIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.MASTER} {...iconProps} />
);

export const MenuIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.MENU} {...iconProps} />
);

export const MessageFormatIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.MESSAGE_FORMAT} {...iconProps} />
);

export const MetamodelIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.METAMODEL} {...iconProps} />
);

export const MetricIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.METRIC} {...iconProps} />
);

export const MiscIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.MISC} {...iconProps} />
);

export const MoonIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.MOON} {...iconProps} />
);

export const NavigateIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.NAVIGATE} {...iconProps} />
);

export const NetworkZoneIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.NETWORK_ZONE} {...iconProps} />
);

export const NewIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.NEW} {...iconProps} />
);

export const NewTextIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.NEW_TEXT} {...iconProps} />
);

export const NodeIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.NODE} {...iconProps} />
);

export const NodeDistanceIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.NODE_DISTANCE} {...iconProps} />
);

export const FormatColorResetIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FORMAT_COLOR_RESET} {...iconProps} />
);

export const NumberIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.NUMBER} {...iconProps} />
);

export const ObjectiveIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.OBJECTIVE} {...iconProps} />
);

export const OpenLinkIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.OPEN_LINK} {...iconProps} />
);

export const OpenedFolderIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.OPENED_FOLDER} {...iconProps} />
);

export const OptimizeLayoutIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.OPTIMIZE_LAYOUT} {...iconProps} />
);

export const OrganizationIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ORGANIZATION} {...iconProps} />
);

export const OrganizationalUnitIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ORGANIZATIONAL_UNIT} {...iconProps} />
);

export const OrientationVerticalIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ORIENTATION_VERTICAL} {...iconProps} />
);

export const PaintBrushIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PAINT_BRUSH} {...iconProps} />
);

export const ParentChildIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PARENT_CHILD} {...iconProps} />
);

export const PasteIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PASTE} {...iconProps} />
);

export const PathIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PATH} {...iconProps} />
);

export const PatternIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PATTERN} {...iconProps} />
);

export const PeopleIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PEOPLE} {...iconProps} />
);

export const PersonaIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PERSONA} {...iconProps} />
);

export const PersonUcIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PERSON_UC} {...iconProps} />
);

export const PieChartFilledIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PIE_CHART_FILLED} {...iconProps} />
);

export const PinIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PIN} {...iconProps} />
);

export const PinOutlineIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PIN_OUTLINE} {...iconProps} />
);

export const PlusOneIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PLUS_ONE} {...iconProps} />
);

export const PowerBiIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.POWER_BI} {...iconProps} />
);

export const PresentationIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PRESENTATION} {...iconProps} />
);

export const ProcessIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PROCESS} {...iconProps} />
);

export const ProcessActivityIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PROCESS_ACTIVITY} {...iconProps} />
);

export const ProductIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PRODUCT} {...iconProps} />
);

export const ProductUpdatesIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PRODUCT_UPDATES} {...iconProps} />
);

export const RadioSelectedIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.RADIO_SELECTED} {...iconProps} />
);

export const RadioUnselectedIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.RADIO_UNSELECTED} {...iconProps} />
);

export const RandomIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.RANDOM} {...iconProps} />
);

export const RedoIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.REDO} {...iconProps} />
);

export const ReferenceTypeIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.REFERENCE_TYPE} {...iconProps} />
);

export const RequirementIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.REQUIREMENT} {...iconProps} />
);

export const RhombusIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.RHOMBUS} {...iconProps} />
);

export const RiskIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.RISK} {...iconProps} />
);

export const RoadMapIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ROAD_MAP} {...iconProps} />
);

export const RobotIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ROBOT} {...iconProps} />
);

export const RocketIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ROCKET} {...iconProps} />
);

export const RoleIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ROLE} {...iconProps} />
);

export const RoleAdminIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ROLE_ADMIN} {...iconProps} />
);

export const RotateIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ROTATE} {...iconProps} />
);

export const ScenarioIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SCENARIO} {...iconProps} />
);

export const ScenarioMergeIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SCENARIO_MERGE} {...iconProps} />
);

export const SelectListIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SELECT_LIST} {...iconProps} />
);

export const SeparateReferencesIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SEPARATE_REFERENCES} {...iconProps} />
);

export const ServerIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SERVER} {...iconProps} />
);

export const ShiftxIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SHIFTX} {...iconProps} />
);

export const ShowComponentIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SHOW_COMPONENT} {...iconProps} />
);

export const SitemapIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SITEMAP} {...iconProps} />
);

export const SortAscIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SORT_ASC} {...iconProps} />
);

export const SpaceBarCrossedIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SPACE_BAR_CROSSED} {...iconProps} />
);

export const SparklesIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SPARKLES} {...iconProps} />
);

export const SpinnerIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SPINNER} {...iconProps} />
);

export const SplitScreenIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SPLIT_SCREEN} {...iconProps} />
);

export const SquareIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SQUARE} {...iconProps} />
);

export const SsoIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SSO} {...iconProps} />
);

export const StackedBarChartIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.STACKED_BAR_CHART} {...iconProps} />
);

export const StarIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.STAR} {...iconProps} />
);

export const StarBorderIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.STAR_BORDER} {...iconProps} />
);

export const StepIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.STEP} {...iconProps} />
);

export const StrategyIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.STRATEGY} {...iconProps} />
);

export const StrikethroughIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.STRIKETHROUGH} {...iconProps} />
);

export const SubjectAreaIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SUBJECT_AREA} {...iconProps} />
);

export const SunIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SUN} {...iconProps} />
);

export const SurveysIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SURVEYS} {...iconProps} />
);

export const Swap2Icon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SWAP_2} {...iconProps} />
);

export const SwapHorizontalIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SWAP_HORIZONTAL} {...iconProps} />
);

export const SwitchCenterIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SWITCH_CENTER} {...iconProps} />
);

export const SyncIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SYNC} {...iconProps} />
);

export const TableColumnsIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TABLE_COLUMNS} {...iconProps} />
);

export const TableRowsIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TABLE_ROWS} {...iconProps} />
);

export const TagIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TAG} {...iconProps} />
);

export const TagOffIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TAG_OFF} {...iconProps} />
);

export const TechnicalCapabilityIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TECHNICAL_CAPABILITY} {...iconProps} />
);

export const TechnologyHealthCheckIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TECHNOLOGY_HEALTH_CHECK} {...iconProps} />
);

export const TechnologyProductIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TECHNOLOGY_PRODUCT} {...iconProps} />
);

export const TechnologyServiceIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TECHNOLOGY_SERVICE} {...iconProps} />
);

export const TextAreaIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TEXT_AREA} {...iconProps} />
);

export const TextFormatIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TEXT_FORMAT} {...iconProps} />
);

export const ThumbDownIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.THUMB_DOWN} {...iconProps} />
);

export const ThumbDownOutlineIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.THUMB_DOWN_OUTLINE} {...iconProps} />
);

export const ThumbUpIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.THUMB_UP} {...iconProps} />
);

export const ThumbUpOutlineIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.THUMB_UP_OUTLINE} {...iconProps} />
);

export const TimeIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TIME} {...iconProps} />
);

export const TimelineViewIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TIMELINE_VIEW} {...iconProps} />
);

export const TodayIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TODAY} {...iconProps} />
);

export const TransformationFutureStateIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TRANSFORMATION_FUTURE_STATE} {...iconProps} />
);

export const TransparentIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TRANSPARENT} {...iconProps} />
);

export const TreeStructureIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TREE_STRUCTURE} {...iconProps} />
);

export const TrophyIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TROPHY} {...iconProps} />
);

export const TuneSettingsIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TUNE_SETTINGS} {...iconProps} />
);

export const UndoIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.UNDO} {...iconProps} />
);

export const UnknownIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.UNKNOWN} {...iconProps} />
);

export const UnpinOutlineIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.UNPIN_OUTLINE} {...iconProps} />
);

export const UrlIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.URL} {...iconProps} />
);

export const ValuePropIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.VALUE_PROP} {...iconProps} />
);

export const ValueStreamIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.VALUE_STREAM} {...iconProps} />
);

export const ValueStreamStageIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.VALUE_STREAM_STAGE} {...iconProps} />
);

export const ViewInferenceIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.VIEW_INFERENCE} {...iconProps} />
);

export const ViewpointIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.VIEWPOINT} {...iconProps} />
);

export const VulnerabilityIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.VULNERABILITY} {...iconProps} />
);

export const WarningIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.WARNING} {...iconProps} />
);

export const WindowFloatingIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.WINDOW_FLOATING} {...iconProps} />
);

export const WindowFullscreenIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.WINDOW_FULLSCREEN} {...iconProps} />
);

export const WindowSidebarIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.WINDOW_SIDEBAR} {...iconProps} />
);

export const WorkspaceIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.WORKSPACE} {...iconProps} />
);

export const WorkspaceDefinitionIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.WORKSPACE_DEFINITION} {...iconProps} />
);

export const ZoomToFitIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ZOOM_TO_FIT} {...iconProps} />
);

export const TextCompareIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.TEXT_COMPARE} {...iconProps} />
);

export const FlowsheetIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FLOWSHEET} {...iconProps} />
);

export const HighlightIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.HIGHLIGHT} {...iconProps} />
);

export const SpeechBubbleIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SPEECH_BUBBLE} {...iconProps} />
);

export const PercentageIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PERCENTAGE} {...iconProps} />
);

export const CustomerServiceIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.CUSTOMER_SERVICE} {...iconProps} />
);

export const DetailsIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.DETAILS} {...iconProps} />
);

export const SidebarCloseIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SIDEBAR_CLOSE} {...iconProps} />
);

export const SidebarOpenIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SIDEBAR_OPEN} {...iconProps} />
);

export const ReportsIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.REPORTS} {...iconProps} />
);

export const SolutionsIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.SOLUTIONS} {...iconProps} />
);

export const MyTasksIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.MY_TASKS} {...iconProps} />
);

export const MyAccountIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.MY_ACCOUNT} {...iconProps} />
);

export const AdminIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ADMIN} {...iconProps} />
);

export const FolderLineIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.FOLDER_LINE} {...iconProps} />
);

export const ProductPortalIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.PRODUCT_PORTAL} {...iconProps} />
);

export const VideoTutorialsIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.VIDEO_TUTORIALS} {...iconProps} />
);

export const NotificationsWithDotIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.NOTIFICATIONS_WITH_DOT} {...iconProps} />
);

export const AccessReadIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ACCESS_READ} {...iconProps} />
);

export const AccessServiceAccountIcon = (iconProps: Omit<IconProps, 'iconName'>) => (
  <Icon iconName={IconName.ACCESS_SERVICE_ACCOUNT} {...iconProps} />
);
